import CommonUtils from './common-utils';




export default class AdLogs { 
    // 페이스북 픽셀 이벤트로그 전송 (시크린 전용)
    static sendMetaPixelEventLogs(eventName: string, data: Map<string, any> | object){
        // 시크린이 아닐 경우 종료
        ////if(CommonUtils.isSystemLocale('global') != true) return;

        const _window = (window as any);

        // 페이스북 픽셀 이벤트로그 관련 객체 없을 경우 종료
        if(_window.fbq == null) return;
        // 객체 형태로 변환
        const payload = data instanceof Map ? Object.fromEntries(data) : { ...data };

        // fbp 기반 eventID 생성
        const eventId = this.getEventIdFromFbp();
        payload.event_id = eventId;

        switch(eventName) {
            case 'AddToCart' :
            case 'ViewContent' :
            case 'CompleteRegistration':
            case 'InitiateCheckout' :
                _window.fbq('track', eventName, payload, {eventID: eventId});
                break;
            case 'Purchase' :
                _window.fbq('track', 'Purchase', payload, {eventID: eventId});
                break;
            case 'Purchase_Sec' :
                _window.fbq('trackCustom', 'Purchase_Sec', payload, {eventID: eventId});
                break;
        }  
    }

      // 쿠키 읽는 헬퍼
    static readCookie(name: string): string | null {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    }

    // _fbp의 4번째 세그먼트를 eventID로 추출
    static getEventIdFromFbp(): string | null {
        const fbp = this.readCookie('_fbp');
        if (!fbp) return null;
        const parts = fbp.split('.');
        // 형식: fb.1.<timestamp>.<random>
        return parts.length >= 4 ? parts[3] : null;
    }

    static sendKakaoPixelEventLogs(eventName: string, data: Map<string,any>| object) {
        const _window = (window as any);
        
        if(_window.kakaoPixel == null) return;
        switch(eventName) {
            case 'Purchase':
                _window.kakaoPixel('9012487525814847947').pageView();
                _window.kakaoPixel('9012487525814847947').purchase(data);
                break;
        }
    }

    // 구글 GTag 이벤트로그 전송 (시크린 전용) -> 파이어베이스로 대체함
    /*
    static sendGTagEventLogs(eventName: string, data: Map<string, any>){
        return;
    }
    */
   
    /** 모비온 구매완료 이벤트 */
    static sendMobionPurchase(data: Map<string,any>| object) {
        const _window = (window as any);
        if (!_window.ENP_VAR) _window.ENP_VAR = {};
        _window.ENP_VAR.conversion = {
        ...data
        };
        CommonUtils.sendMobionLogEvent({ type: 'conversion' });
        setTimeout(() => { _window.ENP_VAR = {}; }, 1500);
    }
    /** 모비온 상품상세 이벤트 */
    static sendMobionProductDetail(data: Map<string,any>| object) {
        const _window = (window as any);
        if (!_window.ENP_VAR) _window.ENP_VAR = {};
        _window.ENP_VAR.collect = {
        ...data
        };
        CommonUtils.sendMobionLogEvent({ type: 'collect' });
        setTimeout(() => { _window.ENP_VAR = {}; }, 1500);
    }

    /** 모비온 장바구니 이벤트 */
    static sendMobionCart(data: Map<string,any>| object) {
        const _window = (window as any);
        if (!_window.ENP_VAR) _window.ENP_VAR = {};
        _window.ENP_VAR.basket = {
        ...data
        };
        CommonUtils.sendMobionLogEvent({ type: 'basket' });
        setTimeout(() => { _window.ENP_VAR = {}; }, 1500);
    }
}